import CancelOrderModal from "components/modals/orderCancel";
import useClearApp from "hooks/useClearApp";
import useData from "hooks/useData";
import React, {useEffect, useState} from "react";
import {HiOutlineChevronLeft, HiOutlineChevronRight} from "react-icons/hi";
import {IoIosWarning} from "react-icons/io";
import {useDispatch} from "react-redux";
import {not} from "utils/helper";
import CardItems from "../../common/products";
import PopularItems from "../../components/popular";
import {getMealMessage} from "../../constants/MESSAGES";

import {saveSelectedCatagory} from "../../Redux/productSlice";
import MenuItem from "../cards/MenuItem";
import CategoryAlertMsg from "../modals/categoryAlertMsg";
import ScanProduct from "./components/ScanProduct";
import {CancelBtn, CardStyle, LeftArrow, ScrollArrow, ScrollItems, TabContainer} from "./index.style";

const SelectTab = ({count, setCount, listItems, setListItems}) => {
    const dispatch = useDispatch();
    const {clearWholeApp} = useClearApp();
    const [clickTab, setClickTab] = useState(false);
    const [cancelOrder, setCancelOrder] = useState(false);
    const [activeTab, setActiveTab] = useState("1");
    const [scrolling, setScrolling] = useState(false);
    const [hideLeftArrow, setHideLeftArrow] = useState(true);
    const [hideRightArrow, setHideRightArrow] = useState(false);
    const [popupDismissed, setPopupDismissed] = useState(false);
    const [showFullMessage, setShowFullMessage] = useState(false);

    const {
        catagories,
        setActive,
        active,
        selectedCatagory,
        formatedMenuData,
        popularData,
    } = useData();

    console.log(catagories(), "catagoriescatagories");

    const onChange = (key) => {
        setActive(key);
    };

    const showCancelOrder = () => {
        setCancelOrder(true);
    };

    const handleCancelOrder = () => {
        clearWholeApp({goBack: false});
        setCancelOrder(false);
    };

    const transform = (container, unit = 0, viaScroll) => {
        if (not(viaScroll)) {
            container.style.transform = `translateX(${unit}px)`;
        }
    };

    function scrollToLeft(viaScroll) {
        const container = document.querySelector(".ant-tabs-nav-list");
        if (container) {
            const currentTransform = getComputedStyle(container).transform;
            const currentX = parseInt(currentTransform.split(",")[4]);
            const newX = currentX + 400; // Adjust the scroll amount as needed
            if (newX <= 0) {
                if (newX > -200) {
                    transform(container, 0, viaScroll);
                    setHideLeftArrow(true);
                    setScrolling(false);
                } else {
                    transform(container, newX, viaScroll);
                }
                setHideRightArrow(false);
            } else {
                setHideLeftArrow(true);
                setScrolling(false);
            }
        }
    }

    function scrollToRight(viaScroll) {
        const container = document.querySelector(".ant-tabs-nav-list");
        if (container) {
            const currentTransform = getComputedStyle(container).transform;
            const currentX = parseInt(currentTransform.split(",")[4]);
            const newX = currentX - 400; // Adjust the scroll amount as needed
            if (newX > -1335) {
                if (-1335 - newX > -200) {
                    transform(container, -1335, viaScroll);
                    setHideRightArrow(true);
                } else {
                    transform(container, newX, viaScroll);
                    setScrolling(true);
                }
                setHideLeftArrow(false);
            } else {
                setHideRightArrow(true);
            }
        }
    }

    const handleOnScroll = ({direction, scroll}) => {
        if (direction === "left") {
            scrollToLeft(scroll);
        } else {
            scrollToRight(scroll);
        }
    };

    useEffect(() => {
        console.log(selectedCatagory, "selectedCatagory");
        console.log(popupDismissed, 'popupDismissed');
        console.log(formatedMenuData, 'formatedMenuData');
    });

    const {show, heading, body} = getMealMessage(selectedCatagory);
    const [visible, setVisible] = useState(false);
    // If selected category has chnaged then we have to rerender the componnet
    useEffect(() => {
        if (show) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [show, selectedCatagory]);
    // Custom function to handle popup dismissal
    const handlePopupDismiss = () => {
        setVisible(false);
        setPopupDismissed(true);
        setShowFullMessage(true);
    };


    const renderMainContent = (show) => (
        <>
            {/* Enable scanner on the main page of the app to scan the product and add to cart */}
            <ScanProduct/>
            <CancelOrderModal
                visible={cancelOrder}
                setVisible={setCancelOrder}
                handleCancelOrder={handleCancelOrder}
            />
            <CancelBtn onClick={showCancelOrder}>Cancel Order</CancelBtn>
            <div>
                <ScrollItems>
                    {!hideRightArrow && (
                        <ScrollArrow
                            onClick={() =>
                                handleOnScroll({direction: "right", scroll: false})
                            }
                        >
                            <HiOutlineChevronRight/>
                        </ScrollArrow>
                    )}
                    {!hideLeftArrow && (
                        <LeftArrow
                            onClick={() =>
                                handleOnScroll({direction: "left", scroll: false})
                            }
                        >
                            <HiOutlineChevronLeft/>
                        </LeftArrow>
                    )}
                </ScrollItems>
                <TabContainer
                    scrolling={scrolling}
                    onTabScroll={(e) => {
                        handleOnScroll({...e, scroll: true});
                    }}
                    activeKey={active}
                    items={catagories()?.map((item, i) => {
                        return {
                            label: (
                                <CardStyle
                                    onClick={() => {
                                        dispatch(
                                            saveSelectedCatagory({
                                                catagory: item?.name,
                                                key: i + 1,
                                            })
                                        );
                                        setClickTab(true);
                                        // Reset message states when changing category
                                        setPopupDismissed(false);
                                        setShowFullMessage(false);
                                    }}
                                >
                                    <MenuItem
                                        clickTab={clickTab}
                                        activeKey={active}
                                        headingName={item.name}
                                        imageUrl={item.image_url}
                                    />
                                </CardStyle>
                            ),
                            key: i + 1,
                        };
                    })}
                    onChange={onChange}
                />
            </div>
            {active === 0 ? (
                <PopularItems
                    setAllCount={setCount}
                    listItems={listItems}
                    setListItems={setListItems}
                    popularData={popularData}
                />
            ) : (
                <>
                    {show && renderFullScreenMessage() || renderCategoryItems({
                        selectedCatagory,
                        setCount,
                        listItems,
                        formatedMenuData,
                        setListItems,
                    })}

                </>
            )}
        </>
    );

    const renderCategoryItems = ({
                                     selectedCatagory,
                                     setCount,
                                     listItems,
                                     formatedMenuData,
                                     setListItems
                                 }) => {
        // debugger
        return (<CardItems
            titleName={selectedCatagory}
            setAllCount={setCount}
            listItems={listItems}
            formatedMenuData={formatedMenuData}
            setListItems={setListItems}
            parentId={selectedCatagory}
        />)
    }

    // Full screen message component
    const renderFullScreenMessage = () => (
        <div style={{

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
            marginTop: "20%"
        }}>
            <div style={{
                width: "100%",
                maxWidth: "500px",
                backgroundColor: "#FFF4E5",
                borderRadius: "12px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                padding: "30px",
                textAlign: "center"
            }}>
                <IoIosWarning style={{
                    color: "#FF9800",
                    fontSize: "64px",
                    marginBottom: "20px"
                }}/>

                <h2 style={{
                    margin: "0 0 16px 0",
                    color: "#E65100",
                    fontSize: "24px",
                    fontWeight: "700"
                }}>
                    {heading}
                </h2>

                <p style={{
                    margin: "0 0 30px 0",
                    color: "#5D4037",
                    fontSize: "18px",
                    lineHeight: "1.5"
                }}>
                    {body}
                </p>

                <div style={{display: "flex", justifyContent: "center", gap: "12px"}}>

                    <button
                        onClick={() => setShowFullMessage(false)}
                        style={{
                            padding: "12px 24px",
                            backgroundColor: "#FF9800",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize: "16px"
                        }}
                    >
                        Please select an alternative option.
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {visible && !popupDismissed ? (
                <CategoryAlertMsg
                    heading={heading}
                    body={body}
                    setVisible={handlePopupDismiss}
                    visible={visible}
                />
            ) : (
                <>
                    {
                        renderMainContent(show) // in this component there is logic to present the screen mesage
                    }

                </>
            )}
        </>
    );
};

export default SelectTab;